import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getBocaRatonStructuredData() {
  const url = "https://restorehair.com/locations/florida/boca-raton/";
  const description =
    "Find out about your hair transplant options in Boca Raton with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("boca-raton", url, description),
    locationPageCrumbs(url, "Boca Raton"),
  ];
}
